import React from 'react';
import MissionList from '../components/Missions/MissionList';

const Missions = () => (
  <div className="missions">
    <MissionList />
  </div>
);

export default Missions;
